import axios from 'axios'

axios.defaults.withCredentials = true;

const state = {
  sidebar: {
    opened: false,
  },
  config: {
    palette: {
      primary: '#4ae387',
      danger: '#e34a4a',
      info: '#4ab2e3',
      success: '#db76df',
      warning: '#f7cc36',
      white: '#fff',
      black: '#000',
      fontColor: '#34495e',
      transparent: 'transparent',
      lighterGray: '#ddd',
    },
  },
  isLoading: true,
  actions: [],
  hashtags: [],
  phrases: [],
  mentions: [],
  processes: []

}

const mutations = {
  setLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  setAccountsList(state, actions) {
    state.actions = actions
  },
  setHashtagsList(state, hashtags) {
    state.hashtags = hashtags
  },
  setPhrasesList(state, phrases) {
    state.phrases = phrases
  },
  setMentionsList(state, mentions) {
    state.mentions = mentions
  },
  setProcessList(state, processes) {
    state.processes = processes
  }

}

const actions = {

  // account action api call
  async listAccountsAction({
    commit,
    state,
  }, payload) {
    return new Promise(async (resolve, reject) => {
      let URL_BUILD = process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_ACCOUNT_API;
      try {
        let response = await axios.get(URL_BUILD);
        if (response.status == 200) {
          await commit("setAccountsList", response.data.data);
          resolve(response.data.data);
        }
      } catch (exception) {
        console.log(exception);
        reject(exception.response.data.err);
      }
    });

  },
  async createAccountsAction({
    commit,
    state,
  }, payload) {
    return new Promise(async (resolve, reject) => {
      let URL_BUILD = process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_ACCOUNT_API;
      try {
        let response = await axios.post(URL_BUILD, payload);
        if (response.status == 200) {
          resolve(response.data.data);
        }
      } catch (exception) {
        reject(exception.response.data.err);
      }
    });

  },
  async removeAccountsAction({
    commit,
    state,
  }, payload) {
    return new Promise(async (resolve, reject) => {
      let URL_BUILD = process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_ACCOUNT_API + '?' + payload;
      try {
        let response = await axios.delete(URL_BUILD);
        if (response.status == 200) {
          resolve();
        }
      } catch (exception) {
        reject(exception.response.data.err);
      }
    });

  },
  // hashtag action api call
  async listHashtagsAction({
    commit,
    state,
  }, payload) {
    return new Promise(async (resolve, reject) => {
      let URL_BUILD = process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_HASHTAG_API;
      try {
        let response = await axios.get(URL_BUILD);
        if (response.status == 200) {
          await commit("setHashtagsList", response.data.data);
          resolve(response.data.data);
        }
      } catch (exception) {
        console.log(exception);
        reject(exception.response.data.err);
      }
    });

  },
  async createHashtagsAction({
    commit,
    state,
  }, payload) {
    return new Promise(async (resolve, reject) => {
      let URL_BUILD = process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_HASHTAG_API;
      try {
        let response = await axios.post(URL_BUILD, payload);
        if (response.status == 200) {
          resolve(response.data.data);
        }
      } catch (exception) {
        reject(exception.response.data.err);
      }
    });

  },
  async removeHashtagsAction({
    commit,
    state,
  }, payload) {
    return new Promise(async (resolve, reject) => {
      let URL_BUILD = process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_HASHTAG_API + '/' + payload;
      try {
        let response = await axios.delete(URL_BUILD);
        if (response.status == 200) {
          resolve();
        }
      } catch (exception) {
        reject(exception.response.data.err);
      }
    });

  },

   // phrase action api call
   async listPhrasesAction({
    commit,
    state,
  }, payload) {
    return new Promise(async (resolve, reject) => {
      let URL_BUILD = process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_PHRASE_API;
      try {
        let response = await axios.get(URL_BUILD);
        if (response.status == 200) {
          await commit("setPhrasesList", response.data.data);
          resolve(response.data.data);
        }
      } catch (exception) {
        console.log(exception);
        reject(exception.response.data.err);
      }
    });

  },
  async createPhrasesAction({
    commit,
    state,
  }, payload) {
    return new Promise(async (resolve, reject) => {
      let URL_BUILD = process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_PHRASE_API;
      try {
        let response = await axios.post(URL_BUILD, payload);
        if (response.status == 200) {
          resolve(response.data.data);
        }
      } catch (exception) {
        reject(exception.response.data.err);
      }
    });

  },
  async removePhrasesAction({
    commit,
    state,
  }, payload) {
    return new Promise(async (resolve, reject) => {
      let URL_BUILD = process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_PHRASE_API + '/' + payload;
      try {
        let response = await axios.delete(URL_BUILD);
        if (response.status == 200) {
          resolve();
        }
      } catch (exception) {
        reject(exception.response.data.err);
      }
    });

  },
  // mention action api call
  async listMentionsAction({
    commit,
    state,
  }, payload) {
    return new Promise(async (resolve, reject) => {
      let URL_BUILD = process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_MENTION_API;
      try {
        let response = await axios.get(URL_BUILD);
        if (response.status == 200) {
          await commit("setMentionsList", response.data.data);
          resolve(response.data.data);
        }
      } catch (exception) {
        console.log(exception);
        reject(exception.response.data.err);
      }
    });

  },
  async createMentionsAction({
    commit,
    state,
  }, payload) {
    return new Promise(async (resolve, reject) => {
      let URL_BUILD = process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_MENTION_API;
      try {
        let response = await axios.post(URL_BUILD, payload);
        if (response.status == 200) {
          resolve(response.data.data);
        }
      } catch (exception) {
        reject(exception.response.data.err);
      }
    });

  },
  async removeMentionsAction({
    commit,
    state,
  }, payload) {
    return new Promise(async (resolve, reject) => {
      let URL_BUILD = process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_MENTION_API + '/' + payload;
      try {
        let response = await axios.delete(URL_BUILD);
        if (response.status == 200) {
          resolve();
        }
      } catch (exception) {
        reject(exception.response.data.err);
      }
    });

  },
  async listProcessAction({
    commit,
    state,
  }, payload) {
    return new Promise(async (resolve, reject) => {
      let URL_BUILD = process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_PROCESS_API;
      try {
        let response = await axios.get(URL_BUILD);
        if (response.status == 200) {
          await commit("setProcessList", response.data.data);
          resolve(response.data.data);
        }
      } catch (exception) {
        console.log(exception);
        reject(exception.response.data.err);
      }
    });
  },
  async removeProcessAction({
    commit,
    state,
  }, payload) {
    return new Promise(async (resolve, reject) => {
      let URL_BUILD = process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_PROCESS_API + '/' + payload;
      try {
        let response = await axios.delete(URL_BUILD);
        if (response.status == 200) {
          resolve();
        }
      } catch (exception) {
        reject(exception.response.data.err);
      }
    });
  },
  async launchDefaultProcessAction({
    commit,
    state,
  }, payload) {
    return new Promise(async (resolve, reject) => {
      let URL_BUILD = process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_PROCESS_API + '/default';
      try {
        let response = await axios.post(URL_BUILD, payload);
        if (response.status == 200) {
          resolve();
        }
      } catch (exception) {
        reject(exception.response.data.err);
      }
    });
  },

  /**
   * Launch new shoort lived process
   */
  launchProcessAction({commit,state,}, payload) {

    return new Promise((resolve, reject) => {
      
      return axios.post(`${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_PROCESS_API}/launch`, payload).then( response => {
        console.log(response.data)  
        return resolve(response.data)

      }).catch( error => reject(error))

    });
  },
}

export default {
  state,
  mutations,
  actions
}